<script context="module" lang="ts">
	export type Member = {
		username: string;
		permission: string;
		storeId: string;
		userId: string;
		error: string;
		name?: string;
		cellphone?: string;
		cellphoneCountryCode?: string;
	};
</script>

<script lang="ts">
	//UI
	import MemberBadge from "./MemberBadge.svelte";
	import StorePermissions from "./StorePermissions.svelte";
	import { AdaptiveTextInput } from "@hitit/new_ui";
	//Utils
	import profileImageFallback from "../../../assets/profile.png?raw-base64";
	import axios from "axios";
	import { createEventDispatcher } from "svelte";
	import {
		getNationalPhonenumber,
		addSpacer,
	} from "../../../functions/utils/phone";
	import { t } from "../../../stores";
	import { dataURLtoFile } from "../../utils";

	//Types
	//Props
	export let editmode = false;
	export let member: Member;
	//Constants
	const dispatch = createEventDispatcher();
	const defaultimage = URL.createObjectURL(
		dataURLtoFile(profileImageFallback, "DEFAULTIMAGE")
	);

	//Variables
	let userImage = "";
	$: krPhone = addSpacer(
		getNationalPhonenumber(member.cellphone, member.cellphoneCountryCode)
	);
	//Functions
	async function getProfileImage(id: string) {
		try {
			const url = `${"HITIT_IMAGE_URL"}profile/${id}.png?v=${Date.now()}`;
			const r = await axios.get(url, {
				withCredentials: true,
				responseType: "blob",
			});

			if (userImage && userImage !== defaultimage)
				URL.revokeObjectURL(userImage);
			if (!r.data) throw new Error("None data");
			if (r.data) userImage = URL.createObjectURL(r.data);
		} catch (error) {
			console.log("Get Image Error");
			userImage = defaultimage;
			// userImage = to
		}
	}

	function deleteMember() {
		dispatch("DELETE_MEMBER", member);
	}

	//Do
	getProfileImage(member.userId);
</script>

<div class="container" t-id="member" class:editmode={editmode}>
	{#if editmode}
		<div class="input-delete">
			<div class="input" class:error={Boolean(member.error)}>
				<AdaptiveTextInput
					placeholder={$t("mbr.store.Enter_account")}
					error={Boolean(member.error)}
					bind:value={member.username}
				/>
			</div>
			<img
				class="delete"
				src="/img/icons/deleteIcon.png"
				alt="delete"
				on:click={deleteMember}
			/>
		</div>
		{#if member.error}
			<p class="error">{member.error}</p>
		{/if}
		<div class="buttons">
			<StorePermissions bind:permission={member.permission} />
		</div>
	{:else}
		<div class="image-name">
			<img src={userImage} alt="Member_Profile_Image" class="profile-image" />
			<p class="name">{member.name || ""}</p>
			<div class="badge-box">
				<MemberBadge userType={member.permission} />
			</div>
		</div>
		<div class="username-phone">
			<p class="username">{member.username || ""}</p>
			<p class="phone">{krPhone || ""}</p>
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		width: 100%;
		border-radius: 5px;
		display: flex;
		flex-direction: column;
		padding: 20px 10px;
		box-sizing: border-box;
		background-color: #f0f0f4;
		color: #46474b;
		&.editmode {
			padding: 16px 10px;
			gap: 10px;
		}
		.error {
			color: #e54848;
		}
		p.error {
			padding-left: 10px;
			font-size: 0.875rem;
			margin-top: -5px;
		}
		.input-delete {
			display: flex;
			width: 100%;
			gap: 20px;
			.input {
				flex-grow: 1;
				height: 32px;
			}

			.delete {
				width: 31px;
				height: 31px;
				&:hover {
					cursor: pointer;
				}
			}
		}
		.buttons {
			display: flex;
			gap: 10px;
		}
		.badge-box {
			margin-left: auto;
		}
		.image-name {
			display: flex;
			gap: 10px;
			align-items: center;
			font-size: 1.25rem;
			font-weight: 500;
			margin-bottom: 7px;
			.profile-image {
				object-fit: cover;
			}

			.profile-image {
				width: 30px;
				height: 30px;
				border-radius: 30px;
				background-color: #e6e7ed;
			}
		}

		.username-phone {
			display: flex;
			flex-direction: column;
			gap: 10px;
		}
	}

	@include DesktopSize {
		.container {
			padding: 20px;
			&.editmode {
				padding: 24px 20px 20px 30px;
			}

			.input-delete {
				justify-content: space-between;
				.input {
					max-width: 288px;
					font-size: 1.25rem;
				}
			}
			p.error {
				font-size: 1rem;
				margin-top: 0px;
			}
			.image-name {
				font-size: 1.5rem;
				margin-bottom: 10px;

				.profile-image {
					width: 50px;
					height: 50px;
					border-radius: 50px;
				}
			}
			.username-phone {
				font-size: 1.25rem;
			}
		}
	}
</style>
